import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';

import { MainNavChipsComponent } from './main-nav-chips.component';
import { StickyTabsComponent } from '../sticky-tabs/sticky-tabs.component';

/**
 * Shared module owning the canonical global navigation chip row
 * (`<pla-main-nav-chips>`) that sits under the topbar on every PlateX page —
 * Home / Initials / Dateless / Build-Your-Own / 26 Reg / Ultimate Names /
 * Number 1's / Under £200 / Plate Viewer / About Us.
 *
 * Extracted from app.module so feature modules (e.g. new-release-page-v2)
 * can import `<pla-main-nav-chips>` without re-declaring its
 * `<pla-sticky-tabs>` dependency. Same pattern as PlateComponentModule
 * (PR #47) and SearchResultTableModule (PR #48).
 *
 * Declares:
 *   - MainNavChipsComponent — the entry point; renders the chip group +
 *     optional back-link, hosts `<pla-sticky-tabs>` for the chip row.
 *   - StickyTabsComponent — the marquee-style horizontal chip strip
 *     primitive. Used directly by 5 other app.module-declared pages
 *     (initials-search, number-one, compare, search-results, the legacy
 *     new-release-search component); re-exported alongside chips so
 *     those consumers continue to resolve `<pla-sticky-tabs>` after the
 *     declarations move out of app.module.
 *
 * Imports:
 *   - CommonModule — `*ngIf`, `*ngFor`, `[ngClass]`, `[ngStyle]` used in
 *     both templates.
 *   - RouterModule — `[routerLink]` on the back-link in the chips template.
 *   - MatIconModule — `<mat-icon>` chevron in the back-link.
 *
 * Exports MainNavChipsComponent (consumers' primary tag) AND
 * StickyTabsComponent (the 5 other pages depend on its tag directly).
 * If those pages migrate to use `<pla-main-nav-chips>` instead, the
 * sticky-tabs export can drop.
 */
@NgModule({
  declarations: [
    MainNavChipsComponent,
    StickyTabsComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatIconModule,
  ],
  exports: [
    MainNavChipsComponent,
    StickyTabsComponent,
  ],
})
export class MainNavChipsModule {}
